import { PayrollAuditPage } from "../components/payroll/PayrollAuditPage.js";

export const PayrollTechnicalAuditPage = ({
  embedded = false,
}: {
  embedded?: boolean;
}) => <PayrollAuditPage level="technical" embedded={embedded} />;
